import { createUseStyles } from "react-jss";
import { SPACING } from "../../constants/styleGuide";

const RateHistoryStyles = createUseStyles({
	whiteContainer: {
		background: '#ffffff',
		padding: SPACING.s24,
		borderBottom: '2px solid #E3E4E5',
	},
	rateGridContent: {
		padding: SPACING.s16,
		background: '#f4f4f4',
		border: '1px solid #ddd',
		borderRadius: '12px',
		marginBottom: '35px'
	},
	rateDate: {
		fontSize: "12px",
		color: "#74767c",
		paddingLeft: SPACING.s16
	},
	rateHeaderDetails: {
		display: 'flex',
		justifyContent: 'space-between',
		fontSize: '14px',
		paddingLeft: SPACING.s16
	},
	rateTime: {
		color: "#74767c",
		paddingRight: SPACING.s16
	},
	contentSpacing16: {
		paddingBottom: SPACING.s16,
	},
});

export default RateHistoryStyles;
